import React from 'react';
import SVG from 'react-inlinesvg';
import { Text, Link } from '@perch-labs/shrike';
import MegaphoneGraphic from '/images/advocacy/megaphone.svg';
import SolarPanels from '/images/advocacy/solar-panels2.png';
import { copyFor, routes } from 'config';
import { Card, Container } from 'styles';
import { getSupportCopy } from './voice-support-card.utils';

const getCopy = copyFor('solar.voiceSupportCard');

interface Props {
  advocacyCampaign: AdvocacyCampaign;
  margin?: Margin;
  state: string;
  stateAbbreviation: string;
  utilityAccountId: number;
}

export const VoiceSupportCard = (props: Props) => {
  const {
    advocacyCampaign,
    margin,
    state,
    stateAbbreviation,
    utilityAccountId,
  } = props;
  const { advocacy } = routes({ utilityAccountId });
  const { callToActionText, isDefault, numberOfSubmissions } = advocacyCampaign;
  const copy = getSupportCopy({
    isDefault,
    numberOfSubmissions,
    state,
    stateAbbreviation,
  });

  const image = isDefault ? (
    <img alt={getCopy('default.alt')} src={SolarPanels} height="64" />
  ) : (
    <SVG height="67" width="88" src={MegaphoneGraphic} />
  );

  return (
    <Card margin={margin} mobileVariant="flat">
      <Card.Header>
        <Text textStyle="heading700" tag="h2" margin={{ right: '8px' }}>
          {copy.title}
        </Text>
        {image}
      </Card.Header>
      <Card.Content>
        <Text margin={{ bottom: '16px' }}>{callToActionText}</Text>
        <Text>{copy.paragraph}</Text>
        <Container flex justifyContent="center">
          <Link
            type="CTA"
            margin={{ top: '24px' }}
            to={advocacy}
            fullWidth
            color="primaryInverse"
          >
            {getCopy('link')}
          </Link>
        </Container>
      </Card.Content>
    </Card>
  );
};
